
export const styles = {
  actions: {
    m: 1,
    justifyContent: 'flex-end'
  },
  title: {
    fontFamily: 'OpenSansMedium',
    fontSize: '1.375rem'
  },
  subtitle: {
    fontFamily: 'OpenSansMedium',
    fontSize: '1.275rem',
  },
  subHeader: {
    color: 'text.secondary'
  },
  chip: (variant?: string) => ({
    color: getChipColor(variant),
    textTransform: 'uppercase',
    px: 0.5,
    fontFamily: 'OpenSansMedium',
    backgroundColor: getBackgroundColor(variant)
  }),
  cardActions: {
    p: 2,
    gap: 2,
    flexDirection: {xs: 'column-reverse', lg: 'row'}
  },
  returnButton: {
    width: {xs: '100%', lg: 'fit-content'},
    ml: {xs: 1, lg: 'inherit'}
  },
  buttonsBox: {
    display: 'flex',
    width: '100%',
    gap: 2,
    pb: {xs: 2.25, lg: 0},
    borderBottom: {xs: '1px solid #cccccc', lg: 'none'},
    flexDirection: {xs: 'column', lg: 'row'},
    justifyContent: 'flex-end'
  },
  table: {
    border: 'none',
    borderRadius: '0px',
    color: 'black',
    '& .MuiDataGrid-columnHeaderTitle': {
      lineHeight: '1rem',
      whiteSpace: 'normal'
    },
    '& .MuiDataGrid-columnHeaders': {
      border: 'none',
      backgroundColor: 'rgba(249, 250, 251, 1)',
      minHeight: '36px !important',
      maxHeight: '36px !important',
      fontFamily: 'OpenSansBold'
    },
    '& .MuiDataGrid-row.Mui-hovered': {
      backgroundColor: 'transparent'
    },
    '& .MuiDataGrid-cell, & .MuiDataGrid-row': {
      maxHeight: '100% !important',
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: 'transparent'
    },
    '& .MuiDataGrid-columnSeparator': {
      visibility: 'hidden !important'
    },
    '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus': {
      outline: 'none !important'
    },
    '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
      outline: 'none !important',
    },
    '& .bold': {
      fontFamily: 'OpenSansMedium'
    },
    '& .tax': {
      color: 'error.main'
    }
  },
  selectModeButton: (mode: boolean) => ({
    backgroundColor: mode ? 'white' : 'default',
    fontFamily: 'OpenSansMedium',
    textTransform: 'none',
    borderRadius: '4px',
    fontSize: '0.875rem',
    '&:hover': {
      backgroundColor: mode ? 'white' : 'default'
    },
    '&.MuiButtonBase-root': {
      backgroundColor: mode ? 'white' : 'default'
    }
  }),
  dialogActions: {
    justifyContent: 'space-between',
    px: {xs: 1.5, md: 3},
    py: 1.5,
    mr: {xs: 0.75, md: 0},
    flexDirection: {xs: 'column-reverse', md: 'row'},
    gap: {xs: 2, md: 0}
  },
  dialogButton: {
    width: {xs: '100%', md: 'inherit'},
  }
}

const getBackgroundColor = (variant?: string): string => {
  if (variant === 'info') {
    return 'rgb(225,225,225)';
  } else if (variant === 'error') {
    return 'rgb(255,209,209)';
  } else {
    return 'rgb(211,255,209)';
  }
};

const getChipColor = (variant?: string): string => {
  if (variant === 'info') {
    return 'text.secondary';
  } else if (variant === 'error') {
    return 'error.dark';
  } else {
    return 'success.dark';
  }
}
